import Character from "./Character";

export default function Group2(props) {

    return (

        <group

            {...props}
            scale = {[1.1,1.1,1.1]}
           
        >
            <Character
                {...props}

            />
        </group>

    )
}
